<template>
  <f7-page name="ccm-pat-study" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        유형정복 학습
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div class="list">
			<ul>
				<li class="item-content item-input">
					<div class="item-inner">
						<div class="item-title item-label">학습 과정</div>
						<div class="item-input-wrap input-dropdown-wrap">
							<select placeholder="학습과정을 선택하세요." v-model="selectedCourse" @change="onCourseChanged">
								<template v-for="(item, i) in courseList">
									<option :key="'i'+i" :value="item">{{getCourseName(i)}}</option>
								</template>
							</select>
						</div>
					</div>
				</li>
				<li class="item-content item-input">
					<div class="item-inner">
						<div class="item-title item-label">대단원</div>
						<div class="item-input-wrap input-dropdown-wrap">
							<select placeholder="대단원을 선택하세요." v-model="selectedBunit" @change="onBunitChanged">
								<template v-for="(item, i) in selectedCourse.bunitList">
									<option :key="'i'+i" :value="item">{{item.BUNIT_NAME}}</option>
								</template>
							</select>
						</div>
					</div>
				</li>
			</ul>
		</div>

		<div class="list">
			<ul>
				<template v-for="(iItem, i) in sunitList">
					<li :key="'ia'+i" style="background-color:#f0f0f0;" v-if="isExistPat(i, '')">
						<div class="item-content item-inner">
							<div class="item-title">
								<div class="item-header">{{iItem.MUNIT_NAME}}</div>
								<span class="vertical-align-middle">{{iItem.SUNIT_NAME}}</span>
								<a href="#" class="margin-left vertical-align-middle" :data-index="i" @click="startStudySunit(i)">[유형학습]</a>
								<i class="sunit-study-tooltip f7-icons vertical-align-middle">question_circle_fill</i>
							</div>
						</div>
					</li>
					<li :key="'ib'+i" v-if="isExistPat(i, '')">
						<div class="item-content item-inner">
							<div class="item-title">
								<div style="display:flex; flex-direction:row;" v-if="isExistPat(i, 'base')">
									<div style="vertical-align: top; padding:2px 8px;">
										<a href="#" @click="startStudyBase(i)">기본</a>
									</div>
									<div style="white-space:normal; padding:2px;">
										<a href="#" v-for="(jItem,j) in iItem.basePatList" :key="'j'+j" :data-index="i" @click="startStudyBasePat(i, j)">
											<img class="vertical-align-middle" :src="'static/unit/lv'+jItem.UNIT_CONQUER+'.png'" style="margin-left:4px"/>	
										</a>
									</div>
								</div>
								<div style="display:flex; flex-direction:row;" v-if="isExistPat(i, 'app')">
									<div style="vertical-align: top; padding:2px 8px;">
										<a href="#" @click="startStudyApplicate(i)">응용</a>
									</div>
									<div style="white-space:normal; padding:2px;">
										<a href="#" v-for="(jItem,j) in iItem.applicatePatList" :key="'j'+j" :data-index="i" @click="startStudyApplicatePat(i, j)">
											<img class="vertical-align-middle" :src="'static/unit/lv'+jItem.UNIT_CONQUER+'.png'" style="margin-left:4px"/>	
										</a>
									</div>
								</div>
								<div style="display:flex; flex-direction:row;" v-if="isExistPat(i, 'adv')">
									<div style="vertical-align: top; padding:2px 8px;">
										<a href="#" @click="startStudyAdvance(i)">심화</a>
									</div>
									<div style="white-space:normal; padding:2px;">
										<a href="#" v-for="(jItem,j) in iItem.advancePatList" :key="'j'+j" :data-index="i" @click="startStudyAdvancePat(i, j)">
											<img class="vertical-align-middle" :src="'static/unit/lv'+jItem.UNIT_CONQUER+'.png'" style="margin-left:4px"/>	
										</a>
									</div>
								</div>
							</div>
						</div>
					</li>
				</template>
			</ul>
		</div>
   
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

// item.GRADE_ID+'.'+item.REVISE_ID+'.'+item.SEMESTER_ID

const PAT_CONQUER_STUDY_PAT_CNT = 3;

export default {
	components: {

	},
  data() {
    return {
			selectedCourse: {},
			selectedBunit: {},
			courseList: [],
			sunitList: []
    }
  },
  mounted() {
		this.loadCourseBunitList();
		$(document).on('page:reinit', '.page[data-name="ccm-pat-study"]', this.onPageShow);
  },
  methods: {
		onPageShow() {
			this.loadCourseBunitList();
		},
		getCourseName(itemIndex) {
			var item = this.courseList[itemIndex];

			var courseId = item.GRADE_ID + item.SEMESTER_ID;
			var courseName = CONST.courseMap[courseId].name;
	
			return courseName + "(" + item.REVISE_ID + "개정)";
		},
		onCourseChanged() {
			this.selectedBunit = this.selectedCourse.bunitList[0];
			this.onBunitChanged();
		},
		onBunitChanged() {
			this.loadMunitSunitPatList();
		},
		isExistPat(sunitIndex, patType) {
			var item = this.sunitList[sunitIndex];
			var itemPatList = undefined;
			
			if (patType == "base") {
				itemPatList = item.basePatList;
			} else if (patType == "app") {
				itemPatList = item.applicatePatList;
			} else if (patType == "adv") {
				itemPatList = item.advancePatList;
			} else if (patType == "") {
				if (item.basePatList.length > 0 || item.applicatePatList.length > 0 || item.advancePatList.length > 0) {
					return true;
				} else {
					return false;
				}
			}

			return (itemPatList.length > 0);
		},
		getOrderedPatArray(sunitIndex, patType) {
			var item = this.sunitList[sunitIndex];
			var itemPatList = undefined;
			var array = [];

			if (patType == "base") {
				itemPatList = item.basePatList;
			} else if (patType == "app") {
				itemPatList = item.applicatePatList;
			} else if (patType == "adv") {
				itemPatList = item.advancePatList;
			}

			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=0; CONQUER_LV<=6; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}

					for (var i=0; i<itemPatList.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = itemPatList[i];
						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}

			return array;
		},
		startStudySunit(sunitIndex) {
			var item = this.sunitList[sunitIndex];
			var array = [];

			var baseArray = item.basePatList;
			var appArray = item.applicatePatList;
			var advArray = item.advancePatList;

			// 소단원내 우선 순위별로 유형 목록을 구해 옴.

			// 기본유형 부족이하 유형 리스트 추출
			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=0; CONQUER_LV<=3; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}
					
					for (var i=0; i<baseArray.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = baseArray[i];

						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}

			// 응용유형 부족이하 유형 리스트 추출
			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=0; CONQUER_LV<=3; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}
					
					for (var i=0; i<appArray.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = appArray[i];

						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}

			// 심화유형 부족이하 유형 리스트 추출
			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=0; CONQUER_LV<=3; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}
					
					for (var i=0; i<advArray.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = advArray[i];

						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}

			// 기본유형 보통이상 유형 리스트 추출
			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=4; CONQUER_LV<=6; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}
					
					for (var i=0; i<baseArray.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = baseArray[i];

						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}

			// 응용유형 보통이상 유형 리스트 추출
			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=4; CONQUER_LV<=6; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}
					
					for (var i=0; i<appArray.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = appArray[i];

						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}

			// 심화유형 보통이상 유형 리스트 추출
			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				for (var CONQUER_LV=4; CONQUER_LV<=6; CONQUER_LV++) {
					if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
						break;
					}
					
					for (var i=0; i<advArray.length; i++) {
						if (array.length >= PAT_CONQUER_STUDY_PAT_CNT) {
							break;
						}

						var patItem = advArray[i];

						if (patItem.UNIT_CONQUER == CONQUER_LV){
							array.push(patItem.PAT_KEY);
						}
					}
				}
			}
			

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyBase(sunitIndex) {
			var item = this.sunitList[sunitIndex];
			var array = [];

			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				var arr = this.getOrderedPatArray(sunitIndex, "base");
				if (arr.length > 0) {
					var remainCnt = PAT_CONQUER_STUDY_PAT_CNT - array.length;
					for (var i=0; i<arr.length; i++) {
						var patKey = arr[i];
						if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
							array.push( patKey );
						} else {
							break;
						}
					}
				}
			}					

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyApplicate(sunitIndex) {
			var item = this.sunitList[sunitIndex];
			var array = [];

			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				var arr = this.getOrderedPatArray(sunitIndex, "app");
				if (arr.length > 0) {
					var remainCnt = PAT_CONQUER_STUDY_PAT_CNT - array.length;
					for (var i=0; i<arr.length; i++) {
						var patKey = arr[i];
						if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
							array.push( patKey );
						} else {
							break;
						}
					}
				}
			}

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyAdvance(sunitIndex) {
			var item = this.sunitList[sunitIndex];
			var array = [];

			if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
				var arr = this.getOrderedPatArray(sunitIndex, "adv");
				if (arr.length > 0) {
					var remainCnt = PAT_CONQUER_STUDY_PAT_CNT - array.length;
					for (var i=0; i<arr.length; i++) {
						var patKey = arr[i];
						if (array.length < PAT_CONQUER_STUDY_PAT_CNT) {
							array.push( patKey );
						} else {
							break;
						}
					}
				}
			}

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyBasePat(sunitIndex, patIndex) {
			var item = this.sunitList[sunitIndex];
			var studyPatItem = item.basePatList[patIndex];
			var patKey = studyPatItem.PAT_KEY;
			var array = [];
			array.push(patKey);

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyApplicatePat(sunitIndex, patIndex) {
			var item = this.sunitList[sunitIndex];
			var studyPatItem = item.applicatePatList[patIndex];
			var patKey = studyPatItem.PAT_KEY;
			var array = [];
			array.push(patKey);

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
		startStudyAdvancePat(sunitIndex, patIndex) {
			var item = this.sunitList[sunitIndex];
			var studyPatItem = item.advancePatList[patIndex];
			var patKey = studyPatItem.PAT_KEY;
			var array = [];
			array.push(patKey);

			var url = PAGES.SUB_CCM_PAT_CONQUER_APPLY;			
			var param = {
				sunitKey: item.SUNIT_KEY,
				patArray: array
			}
			PAGES.popPage(url, param);
		},
    loadCourseBunitList() {
			var _this = this;
			
			let param = {
			};

			API.ajaxRequest({
				url: API.getCourseBunitListUrl(),
				data: param
			}).then(function (data) {
				_this.courseList = data.courseList;

				if (_this.courseList.length > 0) {

					var found = false;

					for (var i=0; i<_this.courseList.length; i++) {
						var courseItem = _this.courseList[i];
						if (courseItem.lastItem) {
							_this.selectedCourse = courseItem;

							for (var j=0; j<courseItem.bunitList.length; j++) {
								var bunitItem = courseItem.bunitList[j];

								if (bunitItem.lastItem) {
									_this.selectedBunit = bunitItem;
									found = true;
									break;
								}
							}

							break;
						}
					}

					if (!found) {
						_this.selectedCourse = _this.courseList[0];
						_this.selectedBunit = _this.selectedCourse.bunitList[0];
					}
					
					_this.onBunitChanged();
				}
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		loadMunitSunitPatList() {
			var _this = this;

			let param = {
				pBunitKey: _this.selectedBunit.BUNIT_KEY
			};

			API.ajaxRequest({
				url: API.getMunitSunitPatListUrl(),
				data: param
			}).then(function (data) {
				_this.sunitList = data.sunitList;

				_this.$utils.nextTick(function() {
					var tooltip = _this.$f7.tooltip.create({
						targetEl: ".sunit-study-tooltip",
						text: "소단원 유형학습 : 소단원 유형3개씩 학습<br/>기본/응용/심화 : 유형종류별 유형3개씩 학습<br/>개별유형 : 유형1개 학습",
					});

					$(".sunit-study-tooltip").click(function(e) {
						tooltip.show(".sunit-study-tooltip");
						setTimeout(function() {
							tooltip.hide();
						}, 5000);
					});
				});

			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		}
  }
}

</script>